module.exports = __webpack_public_path__ + "media/images/menu-ad-exchange-icon-9151f38cf0353b60d3d83333bb90fd6b.svg";